var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      staticClass: "item",
      attrs: { effect: "dark", content: "Help", placement: "bottom" },
    },
    [
      _c("span", { on: { click: _vm.openHelp } }, [
        _c("span", { staticClass: "help-icon" }, [_vm._v("?")]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }